import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaymentService } from './payment.service';
import { PaymentsListComponent } from './list/payments-list.component';
import { CreatePaymentComponent } from './create/create-payment.component';

import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { AngularDateTimePickerModule } from 'angular2-datetimepicker';
import { InlineEditorModule } from '@qontu/ngx-inline-editor';
import { NgSelectModule } from '@ng-select/ng-select';
import { DropdownsModule } from '../dropdowns/dropdowns.module';

import { NgxSmartModalModule } from 'ngx-smart-modal';
import { ProjectService } from '../../features/projects/project.service';
import { DataTablesModule } from 'angular-datatables';
import { CreateSimilarPaymentComponent } from './similar/create-similar-payment.component';

@NgModule({
  imports: [
    CommonModule,
    DropdownsModule,
    SweetAlert2Module,
    BsDatepickerModule,
    NgSelectModule,
    AngularMultiSelectModule,
    AngularDateTimePickerModule,
    InlineEditorModule,
    NgxSmartModalModule,
    DataTablesModule
  ],
  providers: [
    PaymentService,
    ProjectService
  ],
  declarations: [
    PaymentsListComponent,
    CreatePaymentComponent,
    CreateSimilarPaymentComponent
  ],
  exports: [
    PaymentsListComponent,
    CreatePaymentComponent,
    CreateSimilarPaymentComponent
  ]
})
export class PaymentModule { }



// WEBPACK FOOTER //
// ./client/app/shared/payments/payment.module.ts